import { Injectable } from '@angular/core';
import { Exposer } from './../components/exposer.component';
import { AppComponent } from './../app.component';

Injectable();
export class Status {

    private userLogged = false; // utente autenticato e flusso di login completato
    private dataReadable = false; // permette di visualizzare la sidebar (menu sinistro)
    private loginError = false; // non utilizzato => verificare
    private waitHomeOrders = true; // aspetta finchè gli ordini home non sono caricati
    private waitHomeModels = true; // aspetta finchè i modelli/promozioni home non sono caricati
    private loadingAll; // non utilizzato => verificare
    private readyToDisplay = false; // non utilizzato => verificare
    private waitForUserUnit = false; // non utilizzato => verificare
    private landingPage = ''; // continere la pagina di default
    private appComponent: AppComponent = undefined; // contiene il componente appComponent
    private warpToBasket = false; // impone al componente ordine di mostrare all'utente immediatamente il carrello
    private warpToOrder = false; // impone al componente ordine di mostrare all'utente immediatamente l'ordine
    private sidebarOpen = false; // flag che espone a tutti i componenti lo stato della sidebar
    private globalExposer: Exposer = undefined; // l'espositore principale dei servizi

    // |==========|==========|==========|==========|==========|==========|==========|==========|==========|
    // this variables and methods defines the role impersonification behaviour
    // this is the right place of this variables because the values
    // must to be persistent in order to not lose any changes in the impersonification
    private higherUserFirstInteraction              = false; // is the first interaction of a superior user?
    private clientSelected                          = false; // the agent selected a client?
    private isAgent                                 = false; // is the user an agent?
    private agentSelected                           = false; // the manager selected an agent?
    private isManager                               = false; // is the user a manager?
    private managerSelected                         = false; // the directional user selected a manager?
    private isDirectionalUser                       = false; // is the user a directional user?
    // methods correlated to the superior users
    // is the first interaction of an higher user in the hieracity?
    setHUFI(value)              { this.higherUserFirstInteraction = value; }
    getHUFI()                   { return this.higherUserFirstInteraction; }
    // is the user an agent?
    setIsAgent(value)           { this.isAgent = value; }
    getIsAgent()                { return this.isAgent; }
    // is the user a manager?
    setIsManager(value)         { this.isManager = value; }
    getIsManager()              { return this.isManager; }
    // is the user a directional user?
    setIsDirectionalUser(value) { this.isDirectionalUser = value; }
    getIsDirectionalUser()      { return this.isDirectionalUser; }
    // (if the user is an agent) has the user selected a client?
    setClientSelected(value)    { this.clientSelected = value; }
    getClientSelected()         { return this.clientSelected; }
    // (if the user is a manager) has the user selected an agent?
    setAgentSelected(value)     { this.agentSelected = value; }
    getAgentSelected()          { return this.agentSelected; }
    // (if the user is a directional suer) has the user selected a manager?
    setManagerSelected(value)   { this.managerSelected = value; }
    getManagerSelected()        { return this.managerSelected; }
    // |==========|==========|==========|==========|==========|==========|==========|==========|==========|

    getUserLogged() { return this.userLogged; }

    setUserLogged(value: boolean) { this.userLogged = value; }

    getDataReadable() { return this.dataReadable; }

    setDataReadable(value: boolean) { this.dataReadable = value; }

    getLoginError() { return this.loginError; }

    setLoginError(value: boolean) { this.loginError = value; }

    getWaitHomeOrders() { return this.waitHomeOrders; }

    setWaitHomeOrders(value: boolean) { this.waitHomeOrders = value; }

    getWaitHomeModels() { return this.waitHomeModels; }

    setWaitHomeModels(value: boolean) { this.waitHomeModels = value; }

    getLoadingAll() { return this.loadingAll; }

    setLoadingAll(value: boolean) { this.loadingAll = value; }

    getReadyToDisplay() { return this.readyToDisplay; }

    setReadyToDisplay(value: boolean) { this.readyToDisplay = value; }

    getWaitForUserInit() { return this.waitForUserUnit; }

    setWaitForUserInit(value: boolean) { this.waitForUserUnit = value; }

    getLandingPage() { return this.landingPage; }

    setLandingPage(value: string) { this.landingPage = value; this.appComponent.actualAppZone = value; }

    setAppComponent(value) { this.appComponent = value; }

    getAppComponent() {return this.appComponent; }

    setWarpToBasket(value) { this.warpToBasket = value; }

    getWarpToBasket() { return this.warpToBasket; }

    setWarpToOrder(value) { this.warpToOrder = value; }

    getWarpToOrder() { return this.warpToOrder; }

    setSidebarStatus(value) { this.sidebarOpen = value; }

    getSidebarStatus() { return this.sidebarOpen; }

    setExposer(value) { this.globalExposer = value; }

    getExposer() { return this.globalExposer; }
}



// WEBPACK FOOTER //
// ./src/app/service/status.service.ts